var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"fab":"","x-small":"","depressed":"","color":"transparent"},on:{"click":function($event){}}},[_c('v-img',{attrs:{"src":_vm.icon,"max-width":"24","max-height":"24"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }